import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import axios from 'axios';

function LandingPage() {
  let navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const [isMonthly, setIsMonthly] = useState(true);

  const handleNavigateLogin = () => {
    navigate('../../login');
  };

  const handleNavigateContactPage = () => {
    navigate('../contact');
  };

  const handleChangeLanguage = () => {
    i18n.language === 'ar' ? i18n.changeLanguage('en') : i18n.changeLanguage('ar');
  };

  const handleChangeIsMonthly = () => {
    setIsMonthly(!isMonthly);
  };

  const handlePayment = async price => {
    let authToken = '';
    let id = '';
    let paymentToken = '';

    try {
      let authResponse = await axios.post(
        `${process.env.REACT_APP_PAYMOB_AUTHENTICATION_API_BASEURL}`,
        {
          api_key: process.env.REACT_APP_PAYMOB_API_KEY,
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
      authToken = authResponse.data.token;

      let orderRegisterationResponse = await axios.post(
        `${process.env.REACT_APP_PAYMOB_ORDER_REGISTERATION_API_BASEURL}`,
        {
          auth_token: authToken,
          delivery_needed: 'false',
          amount_cents: '100',
          currency: 'EGP',
          items: [],
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
      id = orderRegisterationResponse.data.id;

      let paymentKeyResponse = await axios.post(
        `${process.env.REACT_APP_PAYMOB_PAYMENT_KEY_API}`,
        {
          auth_token: authToken,
          amount_cents: `${price * 100}`,
          expiration: 3600,
          order_id: id,
          billing_data: {
            apartment: 'NA',
            email: 'a@a.com',
            floor: 'NA',
            first_name: 'Ahmed',
            street: 'NA',
            building: 'NA',
            phone_number: '+86(8)9135210487',
            shipping_method: 'NA',
            postal_code: 'NA',
            city: 'NA',
            country: 'NA',
            last_name: 'Ashour',
            state: 'NA',
          },
          currency: 'EGP',
          integration_id: process.env.REACT_APP_PAYMOB_INTEGRATION_ID,
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
      paymentToken = paymentKeyResponse.data.token;

      window.location.replace(`${process.env.REACT_APP_PAYMOB_IFRAME_LINK}${paymentToken}`);
    } catch (error) {
      if (error.response) {
        // Request made but the server responded with an error
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
      } else if (error.request) {
        // Request made but no response is received from the server.
        console.log(error.request);
      } else {
        // Error occured while setting up the request
        console.log('Error', error.message);
      }
    }
  };

  return (
    <>
      {/* Navbar */}
      <nav className='navbar navbar-expand-lg bg-white fixed-top navbar-custom'>
        <div className={`${i18n.language === 'ar' ? 'flex-row-reverse' : ''} container-fluid`}>
          <div className='col-2 text-center mx-auto'>
            <img src='/Sobol_logo.png' alt='Sobol Logo' height={'50px'} />
          </div>
          <div
            className={`${
              i18n.language === 'ar' ? 'col text-start ms-2 d-flex' : 'col text-end me-2'
            }`}>
            <div
              className={`d-inline-block text-center py-2 ${
                i18n.language === 'ar' ? 'ms-4 order-3' : 'me-4 order-1'
              }`}
              onClick={handleNavigateContactPage}>
              <span role={'button'}>{t('landingPage.contact.button')}</span>
            </div>
            <div
              className={`d-inline-block landing-page__button text-center py-2 order-2`}
              onClick={handleChangeLanguage}
              role={'button'}>
              <span className='text-capitalize'>{i18n.language === 'ar' ? 'en' : 'ar'}</span>
            </div>
            <div
              className={`d-inline-block landing-page__button text-center py-2 ${
                i18n.language === 'ar' ? 'me-3  order-1' : 'ms-3 order-3'
              } `}
              onClick={handleNavigateLogin}
              role={'button'}>
              <span>{t('landingPage.contact.login')}</span>
            </div>
          </div>
        </div>
      </nav>
      {/* 1st section - Welcome section */}
      <div className='mx-0 mt-5 row p-5 landing-page__first-section--background'>
        <div className={`col-lg-7 col-12 ${i18n.language === 'ar' ? 'text-end' : 'text-start'}`}>
          <div
            className={`mb-3 landing-page__first-section--title ${
              i18n.language === 'ar' ? 'text-end' : ''
            }`}>
            {t('landingPage.firstSection.welcomeStatement')}
          </div>
          <div
            className={`mb-3 landing-page__first-section--text ${
              i18n.language === 'ar' ? 'text-end arabic' : ''
            }`}>
            {t('landingPage.firstSection.firstLine')}
          </div>
          <div
            className={`mb-3 landing-page__first-section--text ${
              i18n.language === 'ar' ? 'text-end arabic' : ''
            }`}>
            {t('landingPage.firstSection.secondLine')}
          </div>
        </div>
        <div
          className={`col-lg-5 text-center px-auto pt-lg-5 pt-1 ${
            i18n.language === 'ar' ? 'order-last' : 'order-first'
          }`}>
          <img src='/Illustration1.png' alt='illustration' className='my-auto w-50' />
        </div>
      </div>
      {/* 2nd section - Features */}
      <div className='m-0 row px-5 pb-3'>
        <div className={`${i18n.language === 'ar' ? 'text-end' : 'text-start'}`}>
          <div className='landing-page__second-section--title'>
            {t('landingPage.secondSection.features.title')}
          </div>
        </div>
        <div
          className={`row text-center row-cols-1 row-cols-sm-2 row-cols-lg-3 gx-4 gx-lg-5 gy-4 justify-content-evenly ${
            i18n.language === 'ar' ? 'flex-row-reverse' : ''
          }`}>
          <div className='col'>
            <div className='landing-page__second-section--eyedrop h-100'>
              <div className='row mx-auto mt-2 mb-4 landing-page__second-section--image'>
                <img src='/second-section.png' alt='' />
              </div>
              <div
                className={`row mb-2 p-2 landing-page__second-section--subtitle ${
                  i18n.language === 'ar' ? 'text-end' : 'text-start'
                }`}>
                <span className={`${i18n.language === 'ar' ? 'arabic' : ''}`}>
                  {t('landingPage.secondSection.features.firstEyedrop.title')}
                </span>
              </div>
              <div className={`row ${i18n.language === 'ar' ? 'text-end' : 'text-start'} mb-4 p-2`}>
                <span className={`${i18n.language === 'ar' ? 'arabic' : ''}`}>
                  {t('landingPage.secondSection.features.firstEyedrop.description')}
                </span>
              </div>
            </div>
          </div>
          <div className='col'>
            <div className='landing-page__second-section--eyedrop h-100'>
              <div className='row mx-auto  mt-2 mb-4 landing-page__second-section--image'>
                <img src='/second-section.png' alt='' />
              </div>
              <div
                className={`row mb-2 p-2 landing-page__second-section--subtitle ${
                  i18n.language === 'ar' ? 'text-end' : 'text-start'
                }`}>
                <span className={`${i18n.language === 'ar' ? 'arabic' : ''}`}>
                  {t('landingPage.secondSection.features.secondEyedrop.title')}
                </span>
              </div>
              <div className={`row ${i18n.language === 'ar' ? 'text-end' : 'text-start'} mb-4 p-2`}>
                <span className={`${i18n.language === 'ar' ? 'arabic' : ''}`}>
                  {t('landingPage.secondSection.features.secondEyedrop.description')}
                </span>
              </div>
            </div>
          </div>
          <div className='col'>
            <div className='landing-page__second-section--eyedrop h-100'>
              <div className='row mx-auto mt-2 mb-4 landing-page__second-section--image'>
                <img src='/second-section.png' alt='' />
              </div>
              <div
                className={`row mb-2 p-2 landing-page__second-section--subtitle ${
                  i18n.language === 'ar' ? 'text-end' : 'text-start'
                }`}>
                <span className={`${i18n.language === 'ar' ? 'arabic' : ''}`}>
                  {t('landingPage.secondSection.features.thirdEyedrop.title')}
                </span>
              </div>
              <div className={`row ${i18n.language === 'ar' ? 'text-end' : 'text-start'} mb-4 p-2`}>
                <span className={`${i18n.language === 'ar' ? 'arabic' : ''}`}>
                  {t('landingPage.secondSection.features.thirdEyedrop.description')}
                </span>
              </div>
            </div>
          </div>
          <div className='col'>
            <div className='landing-page__second-section--eyedrop h-100'>
              <div className='row mx-auto  mt-2 mb-4 landing-page__second-section--image'>
                <img src='/second-section.png' alt='' />
              </div>
              <div
                className={`row mb-2 p-2 landing-page__second-section--subtitle ${
                  i18n.language === 'ar' ? 'text-end' : 'text-start'
                }`}>
                <span className={`${i18n.language === 'ar' ? 'arabic' : ''}`}>
                  {t('landingPage.secondSection.features.fourthEyedrop.title')}
                </span>
              </div>
              <div className={`row ${i18n.language === 'ar' ? 'text-end' : 'text-start'} mb-4 p-2`}>
                <span className={`${i18n.language === 'ar' ? 'arabic' : ''}`}>
                  {t('landingPage.secondSection.features.fourthEyedrop.description')}
                </span>
              </div>
            </div>
          </div>
          <div className='col'>
            <div className='landing-page__second-section--eyedrop h-100'>
              <div className='row mx-auto  mt-2 mb-4 landing-page__second-section--image'>
                <img src='/second-section.png' alt='' />
              </div>
              <div
                className={`row mb-2 p-2 landing-page__second-section--subtitle ${
                  i18n.language === 'ar' ? 'text-end' : 'text-start'
                }`}>
                <span className={`${i18n.language === 'ar' ? 'arabic' : ''}`}>
                  {t('landingPage.secondSection.features.fifthEyedrop.title')}
                </span>
              </div>
              <div className={`row ${i18n.language === 'ar' ? 'text-end' : 'text-start'} mb-4 p-2`}>
                <span className={`${i18n.language === 'ar' ? 'arabic' : ''}`}>
                  {t('landingPage.secondSection.features.fifthEyedrop.description')}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* 3rd section - contact section */}
      <div className='m-0 row p-5 landing-page__first-section--background'>
        <div
          className={`col-lg-5 text-center px-auto pt-lg-5 pt-1 ${
            i18n.language === 'ar' ? 'order-first' : 'order-last'
          }`}>
          <img src='/Illustration1.png' alt='illustration' className='my-auto w-50' />
        </div>
        <div className='col-lg-7 col-12 text-center'>
          <div
            className={`mb-3 landing-page__first-section--title ${
              i18n.language === 'ar' ? 'text-end arabic' : 'text-start'
            }`}>
            {t('landingPage.thirdSection.title')}
          </div>
          <div
            className={`mb-3 landing-page__first-section--text ${
              i18n.language === 'ar' ? 'text-end arabic' : 'text-start'
            }`}>
            {t('landingPage.thirdSection.description')}
          </div>
          <div
            className='d-inline-block p-2 mt-3 landing-page__first-section--button'
            onClick={handleNavigateContactPage}
            role={'button'}>
            <span>{t('landingPage.contact.button')}</span>
          </div>
        </div>
      </div>
      {/* 4th section - pricing */}
      <div className='m-0 row px-5 pb-5'>
        <div className={`mt-2 ${i18n.language === 'ar' ? 'text-end' : 'text-start'}`}>
          <div className='landing-page__second-section--title'>
            {t('landingPage.secondSection.pricing.title')}
          </div>
          <div className={`px-0 form-check form-switch my-2`}>
            <div
              className={`row mx-0 ${
                i18n.language === 'ar' ? 'text-end flex-row-reverse' : 'text-start'
              }`}>
              <span
                className={`d-inline-block col-1 ${
                  i18n.language === 'ar' ? 'me-5 order-3' : 'me-4 order-1'
                }`}
                htmlFor='option'>
                {t('landingPage.secondSection.pricing.yearlyOption')}
              </span>
              <input
                className={`col-1 form-check-input d-inline-block order-2
              `}
                type='checkbox'
                role='switch'
                checked={isMonthly}
                id='option'
                onChange={handleChangeIsMonthly}
              />
              <span
                className={`d-inline-block col-1 ${i18n.language === 'ar' ? 'order-1' : 'order-3'}`}
                htmlFor='option'>
                {t('landingPage.secondSection.pricing.monthlyOption')}
              </span>
            </div>
          </div>
        </div>
        <div
          className={`row text-center row-cols-1 row-cols-sm-2 row-cols-lg-3 gx-4 gx-lg-5 gy-2 justify-content-evenly ${
            i18n.language === 'ar' ? 'flex-row-reverse' : ''
          }`}>
          <div className='col'>
            <div className='landing-page__second-section__pricing-plan--border h-100'>
              <div
                className={`row px-3 landing-page__second-section__pricing-plan--title ${
                  i18n.language === 'ar' ? 'text-end' : 'text-start'
                }`}>
                <span className={`${i18n.language === 'ar' ? 'arabic' : ''}`}>
                  {t('landingPage.secondSection.pricing.firstPlan.title')}
                </span>
              </div>
              <div
                className='row text-center landing-page__second-section__pricing-plan--subtitle 
                '>
                {isMonthly ? (
                  <>
                    <span className={`col ${i18n.language === 'ar' ? 'arabic' : ''}`}>
                      <strong className='fs-3'>
                        {t('landingPage.secondSection.pricing.firstPlan.monthlyRate')}{' '}
                      </strong>
                      <span className='landing-page__second-section__pricing-plan--rate'>
                        {t('landingPage.secondSection.pricing.currency')}/
                        {t('landingPage.secondSection.pricing.firstPlan.perMonth')}
                      </span>
                    </span>
                    <span className={`${i18n.language === 'ar' ? 'arabic' : ''} invisible mt-1`}>
                      <strong className='fs-6 text-muted'>
                        {t('landingPage.secondSection.pricing.firstPlan.perYear')}
                      </strong>
                    </span>
                  </>
                ) : (
                  <>
                    <span className={`${i18n.language === 'ar' ? 'arabic' : ''}`}>
                      <strong className='fs-3'>
                        {t('landingPage.secondSection.pricing.firstPlan.yearlyRate')}{' '}
                      </strong>
                      <span className='landing-page__second-section__pricing-plan--rate'>
                        {t('landingPage.secondSection.pricing.currency')}/
                        {t('landingPage.secondSection.pricing.firstPlan.perMonth')}
                      </span>
                    </span>
                    <span className={`${i18n.language === 'ar' ? 'arabic' : ''} mt-1`}>
                      <strong className='fs-6 text-muted'>
                        {t('landingPage.secondSection.pricing.firstPlan.perYear')}
                      </strong>
                    </span>
                  </>
                )}
              </div>
              <hr className='mx-5' />
              <div
                className={`row ${i18n.language === 'ar' ? 'text-end' : 'text-start'} mb-1 px-2`}>
                <span
                  className={`${
                    i18n.language === 'ar' ? 'arabic' : ''
                  } text-center landing-page__second-section__pricing-plan--invoice-number`}>
                  {t('landingPage.secondSection.pricing.firstPlan.invoiceNumber')}{' '}
                  <span className='fs-5 text-muted'>
                    {i18n.language === 'ar' ? ' ' : '/'}
                    {t('landingPage.secondSection.pricing.firstPlan.perMonth')}
                  </span>
                </span>
              </div>
              {isMonthly ? (
                <>
                  {/* <div
                    className='btn btn-primary mb-2'
                    onClick={() => {
                      handlePayment(t('landingPage.secondSection.pricing.firstPlan.monthlyRate'));
                    }}>
                    Pay {t('landingPage.secondSection.pricing.firstPlan.monthlyRate')}{' '}
                    {t('landingPage.secondSection.pricing.currency')}
                  </div> */}
                  <div
                    className='d-inline-block p-2 my-2 landing-page__pricing--button'
                    onClick={handleNavigateContactPage}
                    role={'button'}>
                    <span>{t('landingPage.contact.button')}</span>
                  </div>
                </>
              ) : (
                <>
                  {/* <div
                    className='btn btn-primary mb-2'
                    onClick={() => {
                      handlePayment(1400);
                    }}>
                    Pay 1400 {t('landingPage.secondSection.pricing.currency')}
                  </div> */}
                  <div
                    className='d-inline-block p-2 my-2 landing-page__pricing--button'
                    onClick={handleNavigateContactPage}
                    role={'button'}>
                    <span>{t('landingPage.contact.button')}</span>
                  </div>
                </>
              )}
            </div>
          </div>
          <div className='col'>
            <div className='landing-page__second-section__pricing-plan--border h-100'>
              <div
                className={`row px-3 landing-page__second-section__pricing-plan--title ${
                  i18n.language === 'ar' ? 'text-end' : 'text-start'
                }`}>
                <span className={`${i18n.language === 'ar' ? 'arabic' : ''}`}>
                  {t('landingPage.secondSection.pricing.secondPlan.title')}
                </span>
              </div>
              <div
                className='row text-center landing-page__second-section__pricing-plan--subtitle 
                '>
                {isMonthly ? (
                  <>
                    <span className={`col ${i18n.language === 'ar' ? 'arabic' : ''}`}>
                      <strong className='fs-3'>
                        {t('landingPage.secondSection.pricing.secondPlan.monthlyRate')}{' '}
                      </strong>
                      <span className='landing-page__second-section__pricing-plan--rate'>
                        {t('landingPage.secondSection.pricing.currency')}/
                        {t('landingPage.secondSection.pricing.secondPlan.perMonth')}
                      </span>
                    </span>
                    <span className={`${i18n.language === 'ar' ? 'arabic' : ''} invisible mt-1`}>
                      <strong className='fs-6 text-muted'>
                        {t('landingPage.secondSection.pricing.secondPlan.perYear')}
                      </strong>
                    </span>
                  </>
                ) : (
                  <>
                    <span className={`${i18n.language === 'ar' ? 'arabic' : ''}`}>
                      <strong className='fs-3'>
                        {t('landingPage.secondSection.pricing.secondPlan.yearlyRate')}{' '}
                      </strong>
                      <span className='landing-page__second-section__pricing-plan--rate'>
                        {t('landingPage.secondSection.pricing.currency')}/
                        {t('landingPage.secondSection.pricing.secondPlan.perMonth')}
                      </span>
                    </span>
                    <span className={`${i18n.language === 'ar' ? 'arabic' : ''} mt-1`}>
                      <strong className='fs-6 text-muted'>
                        {t('landingPage.secondSection.pricing.secondPlan.perYear')}
                      </strong>
                    </span>
                  </>
                )}
              </div>
              <hr className='mx-5' />
              <div
                className={`row ${i18n.language === 'ar' ? 'text-end' : 'text-start'} mb-1 px-2`}>
                <span
                  className={`${
                    i18n.language === 'ar' ? 'arabic' : ''
                  } text-center landing-page__second-section__pricing-plan--invoice-number`}>
                  {t('landingPage.secondSection.pricing.secondPlan.invoiceNumber')}{' '}
                  <span className='fs-5 text-muted'>
                    {i18n.language === 'ar' ? ' ' : '/'}
                    {t('landingPage.secondSection.pricing.secondPlan.perMonth')}
                  </span>
                </span>
              </div>
              {isMonthly ? (
                <>
                  {/* <div
                    className='btn btn-primary mb-2'
                    onClick={() => {
                      handlePayment(t('landingPage.secondSection.pricing.secondPlan.monthlyRate'));
                    }}>
                    Pay {t('landingPage.secondSection.pricing.secondPlan.monthlyRate')}{' '}
                    {t('landingPage.secondSection.pricing.currency')}
                  </div> */}
                  <div
                    className='d-inline-block p-2 my-2 landing-page__pricing--button'
                    onClick={handleNavigateContactPage}
                    role={'button'}>
                    <span>{t('landingPage.contact.button')}</span>
                  </div>
                </>
              ) : (
                <>
                  {/* <div
                    className='btn btn-primary mb-2'
                    onClick={() => {
                      handlePayment(
                        t('landingPage.secondSection.pricing.secondPlan.yearlyRate') * 12
                      );
                    }}>
                    Pay {t('landingPage.secondSection.pricing.secondPlan.yearlyRate') * 12}{' '}
                    {t('landingPage.secondSection.pricing.currency')}
                  </div> */}
                  <div
                    className='d-inline-block p-2 my-2 landing-page__pricing--button'
                    onClick={handleNavigateContactPage}
                    role={'button'}>
                    <span>{t('landingPage.contact.button')}</span>
                  </div>
                </>
              )}
            </div>
          </div>
          <div className='col'>
            <div className='landing-page__second-section__pricing-plan--border h-100'>
              <div
                className={`row px-3 landing-page__second-section__pricing-plan--title ${
                  i18n.language === 'ar' ? 'text-end' : 'text-start'
                }`}>
                <span className={`${i18n.language === 'ar' ? 'arabic' : ''}`}>
                  {t('landingPage.secondSection.pricing.thirdPlan.title')}
                </span>
              </div>
              <div
                className='row text-center landing-page__second-section__pricing-plan--subtitle 
                '>
                {isMonthly ? (
                  <>
                    <span className={`col ${i18n.language === 'ar' ? 'arabic' : ''}`}>
                      <strong className='fs-3'>
                        {t('landingPage.secondSection.pricing.thirdPlan.monthlyRate')}{' '}
                      </strong>
                      <span className='landing-page__second-section__pricing-plan--rate'>
                        {t('landingPage.secondSection.pricing.currency')}/
                        {t('landingPage.secondSection.pricing.thirdPlan.perMonth')}
                      </span>
                    </span>
                    <span className={`${i18n.language === 'ar' ? 'arabic' : ''} invisible mt-1`}>
                      <strong className='fs-6 text-muted'>
                        {t('landingPage.secondSection.pricing.thirdPlan.perYear')}
                      </strong>
                    </span>
                  </>
                ) : (
                  <>
                    <span className={`${i18n.language === 'ar' ? 'arabic' : ''}`}>
                      <strong className='fs-3'>
                        {t('landingPage.secondSection.pricing.thirdPlan.yearlyRate')}{' '}
                      </strong>
                      <span className='landing-page__second-section__pricing-plan--rate'>
                        {t('landingPage.secondSection.pricing.currency')}/
                        {t('landingPage.secondSection.pricing.thirdPlan.perMonth')}
                      </span>
                    </span>
                    <span className={`${i18n.language === 'ar' ? 'arabic' : ''} mt-1`}>
                      <strong className='fs-6 text-muted'>
                        {t('landingPage.secondSection.pricing.thirdPlan.perYear')}
                      </strong>
                    </span>
                  </>
                )}
              </div>
              <hr className='mx-5' />
              <div
                className={`row ${i18n.language === 'ar' ? 'text-end' : 'text-start'} mb-1 px-2`}>
                <span
                  className={`${
                    i18n.language === 'ar' ? 'arabic' : ''
                  } text-center landing-page__second-section__pricing-plan--invoice-number`}>
                  {t('landingPage.secondSection.pricing.thirdPlan.invoiceNumber')}{' '}
                  <span className='fs-5 text-muted'>
                    {i18n.language === 'ar' ? ' ' : '/'}
                    {t('landingPage.secondSection.pricing.thirdPlan.perMonth')}
                  </span>
                </span>
              </div>
              {isMonthly ? (
                <>
                  {/* <div
                    className='btn btn-primary mb-2'
                    onClick={() => {
                      handlePayment(t('landingPage.secondSection.pricing.thirdPlan.monthlyRate'));
                    }}>
                    Pay {t('landingPage.secondSection.pricing.thirdPlan.monthlyRate')}{' '}
                    {t('landingPage.secondSection.pricing.currency')}
                  </div> */}
                  <div
                    className='d-inline-block p-2 my-2 landing-page__pricing--button'
                    onClick={handleNavigateContactPage}
                    role={'button'}>
                    <span>{t('landingPage.contact.button')}</span>
                  </div>
                </>
              ) : (
                <>
                  {/* <div
                    className='btn btn-primary mb-2'
                    onClick={() => {
                      handlePayment(
                        t('landingPage.secondSection.pricing.thirdPlan.yearlyRate') * 12
                      );
                    }}>
                    Pay {t('landingPage.secondSection.pricing.thirdPlan.yearlyRate') * 12}{' '}
                    {t('landingPage.secondSection.pricing.currency')}
                  </div> */}
                  <div
                    className='d-inline-block p-2 my-2 landing-page__pricing--button'
                    onClick={handleNavigateContactPage}
                    role={'button'}>
                    <span>{t('landingPage.contact.button')}</span>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
        <div
          className={`d-flex pt-3 landing-page__footer--text ${
            i18n.language === 'ar' ? 'flex-row-reverse text-end' : 'text-start'
          }`}>
          <span className={`d-inline-block`}>
            {t('landingPage.secondSection.pricing.morePackages')}
          </span>
          <span
            className={`d-inline-block landing-page__second-section--subtitle px-1 ${
              i18n.language === 'ar' ? 'arabic' : ''
            }`}
            onClick={handleNavigateContactPage}
            role='button'>
            {t('landingPage.contact.button')}.
          </span>
        </div>
      </div>
      {/* 5th section - footer */}
      <div className='m-0 row text-center px-5 landing-page__first-section--background'>
        <span
          className={`my-2 landing-page__footer--text ${i18n.language === 'ar' ? 'arabic' : ''}`}>
          {t('landingPage.footer.company')}&copy; {t('landingPage.footer.year')}
          {i18n.language === 'ar' ? '،' : ','} {t('landingPage.footer.rights')}.
        </span>
      </div>
    </>
  );
}

export default LandingPage;
